import { render, staticRenderFns } from "./underPerf.container.vue?vue&type=template&id=276604da&scoped=true&"
import script from "./underPerf.container.vue?vue&type=script&lang=js&"
export * from "./underPerf.container.vue?vue&type=script&lang=js&"
import style0 from "./underPerf.container.vue?vue&type=style&index=0&id=276604da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276604da",
  null
  
)

export default component.exports